// extracted by mini-css-extract-plugin
export default {"wrap":"More_wrap__shc9V","menu":"More_menu__45X1J","edit":"More_edit__sEO2i","delete":"More_delete__B8qA2"};